import { render, staticRenderFns } from "./products-group.vue?vue&type=template&id=d085c048&scoped=true"
import script from "./products-group.vue?vue&type=script&lang=js"
export * from "./products-group.vue?vue&type=script&lang=js"
import style0 from "./products-group.vue?vue&type=style&index=0&id=d085c048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d085c048",
  null
  
)

export default component.exports